import {ActionIcon, ActionIconProps} from '@mantine/core'
import React, {forwardRef} from 'react'
import {joinStrings} from '@appscience/utils'

export const TransparentActionIcon: React.FC<ActionIconProps<'button'>> = forwardRef<HTMLButtonElement, ActionIconProps<'button'>>(({
  radius,
  size,
  className,
  children,
  ...props
}, ref) => <ActionIcon
  ref={ref}
  radius={radius || 0}
  size={size || 'lg'}
  className={joinStrings(
    'border-none duration-150 hover:bg-transparent disabled:bg-transparent',
    className,
  )}
  {...props}
>
  {children}
</ActionIcon>)